import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {DelAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class DelUserCommand<T> extends DelAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: number) {
    super(apiService, adapter, `${environment.userApiUrl}/users/${id}`);
  }
}
